import React, { type FC } from 'react';

import { Link } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { DevPreviewBanner } from 'client/blocks-redesign/DevPreviewBanner/DevPreviewBanner';
import { Field } from 'client/blocks-redesign/form/Field/Field';
import { GrammarPageEntities } from 'client/blocks-redesign/grammar/GrammarPageEntities/GrammarPageEntities';
import { GrammarPageIntents } from 'client/blocks-redesign/grammar/GrammarPageIntents/GrammarPageIntents';
import { PageLayout } from 'client/blocks-redesign/Layout/PageLayout';
import { wrapInText } from 'client/lib/i18n-utils';
import { routes } from 'client/lib/routes';
import { Skill } from 'client/model/skill';
import * as keyset from 'i18n/IntentsPage';

import styles from './GrammarPage.module.scss';

interface Props {
    aliceApp: Skill;
    disabled: boolean;
}

const t = i18n(keyset);

export const GrammarPage: FC<Props> = ({ aliceApp, disabled }) => {
    return (
        <PageLayout aliceApp={aliceApp} pageTitle={t('intents-title')}>
            <DevPreviewBanner />
            <Field
                fieldTitle={t('intents-title')}
                fieldDescription={wrapInText((s) => (
                    <Link href={routes.documentation.aliceSkills.nlu} target="_blank" rel="noopener noreferrer">
                        {s}
                    </Link>
                ))(t('intents-description'))}
                containerClassName={styles.grammarField}
            >
                <GrammarPageIntents aliceApp={aliceApp} disabled={disabled} />
            </Field>
            <Field fieldTitle={t('entities-title')} fieldDescription={t('entities-subtitle')}>
                <GrammarPageEntities aliceApp={aliceApp} disabled={disabled} />
            </Field>
        </PageLayout>
    );
};
